import type { CardOption } from 'components/IAP/planningView/cardOptions';
import { STEPPER_FORM_WIDGETS } from 'components/IAP/planningView/stepperFormStatus';

import type { RelatedForm } from './seatCatalog';

/**
 * Seat options with no Planning-P stepper entry; the widget names are
 * `renderWidget` cases.
 */
export const SEAT_ONLY_WIDGETS: Readonly<Record<string, string>> = {
  ICS_211: 'checkInList',
  ICS_221: 'demobilizationCheckOut',
  ASSETS: 'incidentAssets',
  ROSTER: 'incidentRoster',
};

const widgetByBaseId = new Map([
  ...Object.entries(SEAT_ONLY_WIDGETS),
  ...Object.entries(STEPPER_FORM_WIDGETS).map(
    ([widgetName, config]) => [config.baseId, widgetName] as [string, string]
  ),
]);

/** Catalog forms that have a workspace card, in catalog order. */
export function formOptionsForSeat(
  forms: readonly RelatedForm[]
): CardOption[] {
  const options: CardOption[] = [];
  for (const form of forms) {
    const widgetName = widgetByBaseId.get(form.baseId);
    if (!widgetName) continue;
    options.push({ label: form.label, value: widgetName });
  }
  return options;
}
